import type { Prompt } from "@1js/pl-card-components";
import { isMicrosoftPrompt, isTenantPrompt, type Status } from "@1js/pl-types";
import { useReducer } from "react";

type PromptPageState = {
  allPrompts: Prompt[];
  init?: boolean;
  status: Status;
  extensionIconMap?: Record<string, string>;
  allWorkplacePrompts: Prompt[];
  allMicrosoftPrompts: Prompt[];
};

export const initialState: PromptPageState = {
  allPrompts: [],
  init: false,
  status: "loading",
  extensionIconMap: {},
  allWorkplacePrompts: [],
  allMicrosoftPrompts: [],
};

type PromptsPageAction =
  | {
      type: "REQUEST_ALL_PROMPTS_INIT";
    }
  | {
      type: "REQUEST_ALL_PROMPTS_SUCCEED";
      payload: { prompts: Prompt[]; extensionIconMap?: Record<string, string> };
    }
  | {
      type: "REQUEST_ALL_PROMPTS_FAILED";
    };

const reducer = (
  state: PromptPageState,
  action: PromptsPageAction
): PromptPageState => {
  switch (action.type) {
    case "REQUEST_ALL_PROMPTS_INIT":
      return {
        ...state,
        status: "loading",
      };
    case "REQUEST_ALL_PROMPTS_SUCCEED":
      return {
        ...state,
        status: "idle",
        init: true,
        allPrompts: action.payload.prompts,
        extensionIconMap: action.payload.extensionIconMap,
        allWorkplacePrompts: action.payload.prompts.filter((prompt) =>
          isTenantPrompt(prompt)
        ),
        allMicrosoftPrompts: action.payload.prompts.filter((prompt) =>
          isMicrosoftPrompt(prompt)
        ),
      };
    case "REQUEST_ALL_PROMPTS_FAILED":
      return {
        ...state,
        status: "failed",
        init: true,
        allPrompts: [],
        allWorkplacePrompts: [],
        allMicrosoftPrompts: [],
      };
    default:
      return state;
  }
};

function usePrompts() {
  const [state, dispatch] = useReducer(reducer, initialState);

  return {
    state,
    dispatch,
  };
}

export default usePrompts;
